<template>
  <div class="custom-select">
    <!-- 根据链接类型显示不同的输入控件 -->
    <!-- 内部链接 - 显示页面下拉列表：判断条件改为 linkType == 10 -->
    <!-- 核心修改：单选框绑定 子组件自己的私有变量 localType，不再绑定父组件的props -->
    <el-radio-group
      v-model="localType"
      size="mini"
      class="radio-group"
      @change="handleTypeChange"
    >
      <el-radio :label="1">无</el-radio>
      <el-radio :label="2">自定义</el-radio>
    </el-radio-group>
    <div v-if="localType === 2" style="display: flex; align-items: flex-start;justify-content: space-between;">
      <el-select
        v-model="datas.linktype"
        placeholder="请选择跳转类型"
        size="mini"
        class="type-select"
        @change="handleLinkTypeChange($event, 1)"
        clearable
      >
        <el-option label="内部链接" value="10"></el-option>
        <el-option label="外部链接" value="11"></el-option>
      </el-select>
      <div v-if="datas.linktype == 10" style="margin-left: 5px">
        <el-select
          class="type-select-inner"
          style="width: 100%"
          size="mini"
          placeholder="请选择内部页面"
          v-model="datas.http.internalLink"
          @change="handleInternalLinkChange(datas)"
        >
          <el-option
            v-for="page in pagesList"
            :key="page.pageId"
            :label="page.pageName"
            :value="page.pageId"
          >
          </el-option>
        </el-select>
        <el-button
          v-if="!datas.pageId"
          type="primary"
          size="mini"
          @click.stop="
            handleInternalLinkChange({ http: { internalLink: NEW_PAGE_KEY } })
          "
          >+ 新建页面</el-button
        >
      </div>
      <!-- 输入http 外部链接 -->
      <el-input
        classs="input"
        style="margin-left: 5px"
        v-if="datas.linktype == 11"
        v-model="datas.http.externalLink"
        placeholder="请输入跳转链接"
        show-word-limit
      />
    </div>
    <!-- 暂时不用 后续需要打开 -->
    <!-- 引入编辑弹窗组件 -->
    <!-- <EditDialog
      ref="editDialog"
      :visible="dialogVisible"
      title="新建页面"
      :fields="formFields"
      :form-rules="formRules"
      :initial-data="formData"
      @update:visible="dialogVisible = $event"
      @confirm="handleConfirm"
      @close="handleClose"
    >
    </EditDialog> -->
  </div>
</template>
<script>
export default {
  name: "CustomSelect",
  props: {
    // 父组件传入的默认值，只做初始化用，不做双向绑定
    type: {
      type: [Number, String],
      default: 1,
    },
    datas: {
      type: Object,
      default: () => ({
        http: {
          internalLink: "", // 内部页面ID
          externalLink: "", // 外部跳转链接
        },
      }),
    },
  },
  data() {
    return {
      // ✅ 核心新增：子组件自己的私有变量，接收父组件的初始值
      localType: Number(this.type),
      formData: {
        pageName: "",
        pageId: "",
      },
      formFields: [
        {
          label: "页面名称",
          prop: "pageName",
          type: "input",
          placeholder: "请输入页面名称",
        },
        {
          label: "页面ID（pageId）",
          prop: "pageId",
          type: "input",
          placeholder: "请输入页面ID",
          regex: /^[a-z]+$/,
          regexMsg: "只能输入小写字母（a-z）",
          filterInput: true,
        },
      ],
      formRules: {
        pageName: [
          {
            required: true,
            message: "请输入页面名称",
            trigger: ["blur", "change"],
          },
        ],
        pageId: [
          {
            required: true,
            message: "请输入页面id",
            trigger: ["blur", "change"],
          },
        ],
      },
      dialogVisible: false,
      selectedOption: "",
      NEW_PAGE_KEY: "_NEW_",
      currentItem: null,
      currentPageId: "",
      hasCreatedAlias: false,
      originalAlias: "",
    };
  },
  computed: {
    pagesList() {
      // 先过滤出首页等链接 后续根据需求操作
      return this.$store.state.modules.templateData.pages.filter(
        (item) => item.pageId  !== 'page_home' &&  item.pageId  !== 'page_notification' && item.pageId  !== 'page_activity'  && item.pageId  !== 'page_user' && item.pageId  !== 'page_find'
      ) || [];
    },
    // 当前组件已绑页面ID（直接挂载在datas根层级）
    hasAlias() {
      return this.datas?.pageId || "";
    },
  },
  created() {
    console.log("下拉选择框组件挂载了", this.datas);
  },
  // 监听父组件传的type变化，同步更新子组件的localType (可选，做了更健壮)
  watch: {
    type(val) {
      this.localType = Number(val);
    },
  },
  methods: {
    // 核心方法：处理跳转类型选择变化，同步更新父组件的datas.linkType
    handleLinkTypeChange(val, type) {
      console.log("跳转类型", val, this.datas);
      this.datas.http.internalLink = ""
      this.datas.http.externalLink = ""
      this.$emit("update:type", val);
    },
    handleTypeChange(val) {
      console.log(
        "CustomSelect子组件的handleTypeChange方法",
        val,
        this.localType,
        this.datas
      );
      

    },
    resetData() {
      this.datas.http = {
        externalLink: "",
        internalLink: "",
      };
      delete this.datas.pageId;
      delete this.datas.pageName;
    },
    handleClose() {
      this.dialogVisible = false;
    },
    // 新建页面
    async handleConfirm(val) {
      const newPage = {
        pageId: this.datas.id || this.datas.pageId,
        isBack: true,
        pageName: this.datas.moduleName || this.datas.text,
        path: this.datas.id || this.datas.pageId,
        pageSetup: this.$store.state.modules.templateData.global,
        components: [],
      };
      this.datas.pageId = newPage.pageId;
      console.log(
        "最终组装的页面pageIdJSON数据是---------",
        newPage,
        this.$store.state.modules.templateData,
        this.datas
      );
      const result = await this.$store.dispatch(
        "modules/addDynamicPage",
        newPage
      );
      if (result.success) {
        this.$message({
          message: "新建页面成功",
          type: "success",
        });
        this.dialogVisible = false;
        this.datas.http.internalLink = this.datas.pageId;
        this.currentPageId = this.datas.pageId;
        console.log(
          "新建页面成功结果",
          this.formData,
          this.datas,
          newPage,
          result,
          this.$store.state.modules.templateData,
          this.pagesList,
          this.hasAlias,
          this.currentPageId
        );
      }
    },
    async handleInternalLinkChange(option) {
      var that = this;
      this.currentPageId = option.pageId || "";
      // 点击新建页面按钮逻辑
      if (option?.http?.internalLink === this.NEW_PAGE_KEY) {
        console.log("走新建页面逻辑", this.datas);
        this.handleConfirm();
      } else {
        // 下拉选择已有页面逻辑
        if (option?.http?.internalLink) {
          const currentItem = this.pagesList.find(
            (item) => item.pageId === option?.http?.internalLink
          );
          if (currentItem) {
            this.datas.pageId = currentItem.pageId;
            this.datas.pageName = currentItem.pageName;
          }
          console.log(
            "走更换事件逻辑了-----------------------",
            this.datas,
            currentItem
          );
        }
      }
      this.$emit("update:datas", this.datas);
    },
  },
};
</script>
<style scoped lang="scss">
::v-deep.el-select.type-select {
  .el-input {
    .el-input__inner {
      width: 120px;
      height: 28px;
      line-height: 28px;
    }
  }
}
::v-deep.el-input{
      .el-input__inner{
        height: 28px;
        line-height: 28px;
      }

}
.custom-select {
}
</style>
